export function getDocuments() {
  return this.get('/documents', {py: true})
}

export function getDocumentMessages(uuid) {
  return this.get(`/api/documents/${uuid}/messages`)
}

export function uploadDocument(data) {
  return this.post('/upload/document', data, {py: true}).request
}

export function deleteDocument(uuid) {
  return this.del(`/delete/document/${uuid}`, {py: true})
}
